import html2canvas from "html2canvas";

const makeImage = () => {

  const converImage = (imageFile) => {
    const imgData = atob(imageFile.split(",")[1]);
    const len = imgData.length;
    const buf = new ArrayBuffer(len); // 비트를 담을 버퍼를 만든다.
    const view = new Uint8Array(buf); // 버퍼를 8bit Unsigned Int로 담는다.
    let blob, i;
    
    for (i = 0; i < len; i++) {
      view[i] = imgData.charCodeAt(i) & 0xff; // 비트 마스킹을 통해 msb를 보호한다.
    }
    // Blob 객체를 image/png 타입으로 생성한다. (application/octet-stream도 가능)
    blob = new Blob([view], { type: "image/png" });
    return blob;
  }

  //이미지 생성
  const makeToIImage = async (sclass) => {
    // html to imageFile
    const paper = document.querySelector("."+sclass);
    const canvas = await html2canvas(paper);
    const imageFile = canvas.toDataURL("image/png", 1.0);
    return imageFile;
  }

  //이미지 다운로드
  const DownloadImage = (imageFile,realFile) => {
    const mobileType = navigator.userAgent.toLowerCase();

    //안드로이드의 경우
    if (mobileType.indexOf('android') > -1) {
      if(window.mamamonte){
        window.mamamonte.downloadBase64File(imageFile, realFile, 'application/octet-stream');
        alert('다운로드가 완료되었습니다.');
      }
    //일반
    } else {
      if (window.navigator.msSaveOrOpenBlob) {
        const blob = converImage(imageFile);
        window.navigator.msSaveOrOpenBlob(blob, realFile);
      } else {
        const a = document.createElement('a');
        a.setAttribute('style','display:none');
        a.href = imageFile;
        a.download = realFile;  //실제파일명
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
        },100);
      }
    }
  }

  return {
    viewWithImage: async (sclass,realFile) => {
      // html to imageFile
      const imageFile = await makeToIImage(sclass);
      // imageFile to PDF
      //const pdf = converToPDF(imageFile);
      DownloadImage(imageFile,realFile);
    }
  }

}

export default makeImage
